import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { AuthProvider, useAuth } from './context/AuthContext';

// Main Application Layout
import Layout from './components/Layout';


// Main Application Pages (inside the layout)
import Overview from './pages/Overview';
import Profile from './pages/Profile';
import Assets from './pages/Assets';
import Liability from './pages/Liability';
import Insurance from './pages/Insurance';
import Income from './pages/Income';
import Expenses from './pages/Expenses';
import Goals from './pages/Goals';
import Login from './pages/Login';
import Register from './pages/Register';
import Settings from './pages/Settings';
import CompleteProfile from './pages/CompleteProfile';

// Protected Route Component
import ProtectedRoute from './components/ProtectedRoute';
import { LookupProvider } from './context/LookupContext';

// Home component to redirect based on auth status
const HomeRedirect: React.FC = () => {
  const { isAuthenticated, user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // <-- Yahaan logic update kiya gaya hai
  // Agar user authenticated hai, to check karo profile complete hai ya nahi
  // return user?.isProfileComplete ? <Navigate to="/Overview" replace /> : <Navigate to="/CompleteProfile" replace />;
  return <Navigate to="/Overview" replace /> 
};

// LayoutWrapper component for protected routes
const LayoutWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ProtectedRoute>
      <Layout>
        {children}
      </Layout>
    </ProtectedRoute>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppProvider>
          <LookupProvider>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Home route */}
            <Route path="/" element={<HomeRedirect />} />

            {/* All protected routes with layout */}
            <Route path="/CompleteProfile" element={<LayoutWrapper><CompleteProfile /></LayoutWrapper>} />
            <Route path="/Overview" element={<LayoutWrapper><Overview /></LayoutWrapper>} />
            <Route path="/profile" element={<LayoutWrapper><Profile /></LayoutWrapper>} />
            <Route path="/assets" element={<LayoutWrapper><Assets /></LayoutWrapper>} />
            <Route path="/liability" element={<LayoutWrapper><Liability /></LayoutWrapper>} />
            <Route path="/insurance" element={<LayoutWrapper><Insurance /></LayoutWrapper>} />
            <Route path="/income" element={<LayoutWrapper><Income /></LayoutWrapper>} />
            <Route path="/expenses" element={<LayoutWrapper><Expenses /></LayoutWrapper>} />
            <Route path="/goals" element={<LayoutWrapper><Goals /></LayoutWrapper>} />
            <Route path="/settings" element={<LayoutWrapper><Settings /></LayoutWrapper>} />
           
            {/* Catch all route - 404 handling */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
        </LookupProvider>
      </AppProvider>
    </AuthProvider>
  );
}

export default App;